import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useAuth } from "../../../AuthenticationStore";
import ChartBar from "../../../components/Charts/Bar";
import ChartLine from "../../../components/Charts/Line";
import ChartPie from "../../../components/Charts/Pie";
import { Container, Grid } from "semantic-ui-react";

const CampaignDashboard = () => {
  let { campaignId } = useParams();
  const { indicatorService } = useAuth();

  const [dashboardName, setDashboardName] = useState([]);

  const [
    categoriesIndicatorCustomerForDays,
    setCategoriesIndicatorCustomerForDays
  ] = useState({});

  const [
    seriesIndicatorCustomerForDays,
    setSeriesIndicatorCustomerForDays
  ] = useState([]);

  const [
    categoriesIndicatorAmountForDays,
    setCategoriesIndicatorAmountForDays
  ] = useState({});
  const [
    seriesIndicatorAmountForDays,
    setSeriesIndicatorAmountForDays
  ] = useState([]);

  const [
    categoriesIndicatorMultiBarCustomerForDays,
    setCategoriesIndicatorMultiBarCustomerForDays
  ] = useState({});
  const [
    seriesIndicatorMultiBarCustomerForDays,
    setSeriesIndicatorMultiBarCustomerForDays
  ] = useState([]);

  const [
    categoriesIndicatorMultiBarAmountForDays,
    setCategoriesIndicatorMultiBarAmountForDays
  ] = useState({});
  const [
    seriesIndicatorMultiBarAmountForDays,
    setSeriesIndicatorMultiBarAmountForDays
  ] = useState([]);

  const [
    categoriesIndicatorAmountChannel,
    setCategoriesIndicatorAmountChannel
  ] = useState({});
  const [
    seriesIndicatorAmountChannel,
    setSeriesIndicatorAmountChannel
  ] = useState([]);

  const [
    categoriesIndicatorCustomerChannel,
    setCategoriesIndicatorCustomerChannel
  ] = useState({});
  const [
    seriesIndicatorCustomerChannel,
    setSeriesIndicatorCustomerChannel
  ] = useState([]);

  const [
    categoriesIndicatorMultiBarCustomerForMonthAndChannel,
    setCategoriesIndicatorMultiBarCustomerForMonthAndChannel
  ] = useState({});
  const [
    seriesIndicatorMultiBarCustomerForMonthAndChannel,
    setSeriesIndicatorMultiBarCustomerForMonthAndChannel
  ] = useState([]);

  const [
    categoriesIndicatorMultiBarAmountForMonthAndChannel,
    setCategoriesIndicatorMultiBarAmountForMonthAndChannel
  ] = useState({});
  const [
    seriesIndicatorMultiBarAmountForMonthAndChannel,
    setSeriesIndicatorMultiBarAmountForMonthAndChannel
  ] = useState([]);

  const [
    categoriesIndicatorSurveyDeclined,
    setCategoriesIndicatorSurveyDeclined
  ] = useState({});
  const [
    seriesIndicatorSurveyDeclined,
    setSeriesIndicatorSurveyDeclined
  ] = useState([]);

  const [
    categoriesIndicatorApprovedSurveyAmount,
    setCategoriesIndicatorApprovedSurveyAmount
  ] = useState({});
  const [
    seriesIndicatorApprovedSurveyAmount,
    setSeriesIndicatorApprovedSurveyAmount
  ] = useState([]);

  const [
    categoriesIndicatorApprovedSurveyCustomer,
    setCategoriesIndicatorApprovedSurveyCustomer
  ] = useState({});
  const [
    seriesIndicatorApprovedSurveyCustomer,
    setSeriesIndicatorApprovedSurveyCustomer
  ] = useState([]);

  useEffect(() => {
    if (!indicatorService) return;

    const getDetailCampaign = async () => {
      const responseCampaigns = await indicatorService.getDashboardCampaign(
        campaignId
      );
      const indicators = responseCampaigns.object || [];

      setDashboardName(indicators.name);

      // ===========>
      setCategoriesIndicatorCustomerForDays(
        indicators.indicatorCustomerForDays.categories
      );
      setSeriesIndicatorCustomerForDays(
        indicators.indicatorCustomerForDays.series
      );

      // ===========>
      setCategoriesIndicatorAmountForDays(
        indicators.indicatorAmountForDays.categories
      );
      setSeriesIndicatorAmountForDays(indicators.indicatorAmountForDays.series);

      // ===========>
      setCategoriesIndicatorMultiBarCustomerForDays(
        indicators.indicatorMultiBarCustomerForDays.categories
      );
      setSeriesIndicatorMultiBarCustomerForDays(
        indicators.indicatorMultiBarCustomerForDays.series.map(item => {
          item.name = item.nameCategory;
          item.data = item.values;
          return item;
        })
      );
      // ==========>
      setCategoriesIndicatorMultiBarAmountForDays(
        indicators.indicatorMultiBarAmountForDays.categories
      );
      setSeriesIndicatorMultiBarAmountForDays(
        indicators.indicatorMultiBarAmountForDays.series.map(item => {
          item.name = item.nameCategory;
          item.data = item.values;
          return item;
        })
      );
      // ========>
      setCategoriesIndicatorAmountChannel(
        indicators.indicatorAmountChannel.categories
      );
      setSeriesIndicatorAmountChannel(indicators.indicatorAmountChannel.series);
      // ========>
      setCategoriesIndicatorCustomerChannel(
        indicators.indicatorCustomerChannel.categories
      );
      setSeriesIndicatorCustomerChannel(
        indicators.indicatorCustomerChannel.series
      );
      // ========>
      setCategoriesIndicatorMultiBarCustomerForMonthAndChannel(
        indicators.indicatorMultiBarCustomerForMonthAndChannel.categories
      );
      setSeriesIndicatorMultiBarCustomerForMonthAndChannel(
        indicators.indicatorMultiBarCustomerForMonthAndChannel.series.map(
          item => {
            item.name = item.nameCategory;
            item.data = item.values;
            return item;
          }
        )
      );
      // =========>
      setCategoriesIndicatorMultiBarAmountForMonthAndChannel(
        indicators.indicatorMultiBarAmountForMonthAndChannel.categories
      );
      setSeriesIndicatorMultiBarAmountForMonthAndChannel(
        indicators.indicatorMultiBarAmountForMonthAndChannel.series.map(
          item => {
            item.name = item.nameCategory;
            item.data = item.values;
            return item;
          }
        )
      );
      // ===========>
      setCategoriesIndicatorSurveyDeclined(
        indicators.indicatorSurveyDeclined.categories
      );
      setSeriesIndicatorSurveyDeclined(
        indicators.indicatorSurveyDeclined.series
      );
      // ===========>
      setCategoriesIndicatorApprovedSurveyAmount(
        indicators.indicatorApprovedSurveyAmount.categories
      );
      setSeriesIndicatorApprovedSurveyAmount(
        indicators.indicatorApprovedSurveyAmount.series
      );
      // ===========>
      setCategoriesIndicatorApprovedSurveyCustomer(
        indicators.indicatorApprovedSurveyCustomer.categories
      );
      setSeriesIndicatorApprovedSurveyCustomer(
        indicators.indicatorApprovedSurveyCustomer.series
      );
    };

    getDetailCampaign();
  }, [campaignId, indicatorService]);

  return (
    <Container>
      <Grid>
        <Grid.Row>
          <h1>
            {" "}
            <i className="fa fa-tags"></i> {dashboardName}
          </h1>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            <div className="card card-chart">
              <div className="card-body px-0 pb-0 border-bottom">
                <div className="px-4">
                  <div className="d-flex justify-content-between mb-2">
                    <h4 className="card-title ml-2">
                      <i className="fa fa-bar-chart"></i> Clientes por días
                    </h4>
                  </div>
                </div>
              </div>
              <div className="card-body pt-3">
                <ChartBar
                  categories={categoriesIndicatorCustomerForDays}
                  series={seriesIndicatorCustomerForDays}
                />
              </div>
            </div>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            <div className="card card-chart">
              <div className="card-body px-0 pb-0 border-bottom">
                <div className="px-4">
                  <div className="d-flex justify-content-between mb-2">
                    <h4 className="card-title ml-2">
                      <i className="fa fa-bar-chart"></i> Monto por días
                    </h4>
                  </div>
                </div>
              </div>
              <div className="card-body pt-3">
                <ChartBar
                  categories={categoriesIndicatorAmountForDays}
                  series={seriesIndicatorAmountForDays}
                  isAmount
                />
              </div>
            </div>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            <div className="card card-chart">
              <div className="card-body px-0 pb-0 border-bottom">
                <div className="px-4">
                  <div className="d-flex justify-content-between mb-2">
                    <h4 className="card-title ml-2">
                      <i className="fa fa-line-chart"></i> Multibarra clientes
                      por días
                    </h4>
                  </div>
                </div>
              </div>
              <div className="card-body pt-3">
                <ChartLine
                  categories={categoriesIndicatorMultiBarCustomerForDays}
                  series={seriesIndicatorMultiBarCustomerForDays}
                />
              </div>
            </div>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            <div className="card card-chart">
              <div className="card-body px-0 pb-0 border-bottom">
                <div className="px-4">
                  <div className="d-flex justify-content-between mb-2">
                    <h4 className="card-title ml-2">
                      <i className="fa fa-line-chart"></i> Multibarra monto por
                      días
                    </h4>
                  </div>
                </div>
              </div>
              <div className="card-body pt-3">
                <ChartLine
                  categories={categoriesIndicatorMultiBarAmountForDays}
                  series={seriesIndicatorMultiBarAmountForDays}
                  isAmount
                />
              </div>
            </div>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            <div className="card card-chart">
              <div className="card-body px-0 pb-0 border-bottom">
                <div className="px-4">
                  <div className="d-flex justify-content-between mb-2">
                    <h4 className="card-title ml-2">
                      <i className="fa fa-bar-chart"></i> Monto por canal
                    </h4>
                  </div>
                </div>
              </div>
              <div className="card-body pt-3">
                <ChartBar
                  categories={categoriesIndicatorAmountChannel}
                  series={seriesIndicatorAmountChannel}
                  isAmount
                />
              </div>
            </div>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            <div className="card card-chart">
              <div className="card-body px-0 pb-0 border-bottom">
                <div className="px-4">
                  <div className="d-flex justify-content-between mb-2">
                    <h4 className="card-title ml-2">
                      <i className="fa fa-pie-chart"></i> Clientes por canal
                    </h4>
                  </div>
                </div>
              </div>
              <div className="card-body pt-3">
                <ChartPie
                  categories={categoriesIndicatorCustomerChannel}
                  series={seriesIndicatorCustomerChannel}
                />
              </div>
            </div>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            <div className="card card-chart">
              <div className="card-body px-0 pb-0 border-bottom">
                <div className="px-4">
                  <div className="d-flex justify-content-between mb-2">
                    <h4 className="card-title ml-2">
                      <i className="fa fa-line-chart"></i> Multibarra cliente
                      por mes y canal
                    </h4>
                  </div>
                </div>
              </div>
              <div className="card-body pt-3">
                <ChartLine
                  categories={
                    categoriesIndicatorMultiBarCustomerForMonthAndChannel
                  }
                  seriesMultiple={
                    seriesIndicatorMultiBarCustomerForMonthAndChannel
                  }
                />
              </div>
            </div>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            <div className="card card-chart">
              <div className="card-body px-0 pb-0 border-bottom">
                <div className="px-4">
                  <div className="d-flex justify-content-between mb-2">
                    <h4 className="card-title ml-2">
                      <i className="fa fa-line-chart"></i> Multibarra monto por
                      mes y canal
                    </h4>
                  </div>
                </div>
              </div>
              <div className="card-body pt-3">
                <ChartLine
                  categories={
                    categoriesIndicatorMultiBarAmountForMonthAndChannel
                  }
                  seriesMultiple={
                    seriesIndicatorMultiBarAmountForMonthAndChannel
                  }
                  isAmount
                />
              </div>
            </div>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            <div className="card card-chart">
              <div className="card-body px-0 pb-0 border-bottom">
                <div className="px-4">
                  <div className="d-flex justify-content-between mb-2">
                    <h4 className="card-title ml-2">
                      <i className="fa fa-pie-chart"></i> Encuesta rechazada
                    </h4>
                  </div>
                </div>
              </div>
              <div className="card-body pt-3">
                <ChartPie
                  categories={categoriesIndicatorSurveyDeclined}
                  series={seriesIndicatorSurveyDeclined}
                />
              </div>
            </div>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            <div className="card card-chart">
              <div className="card-body px-0 pb-0 border-bottom">
                <div className="px-4">
                  <div className="d-flex justify-content-between mb-2">
                    <h4 className="card-title ml-2">
                      <i className="fa fa-bar-chart"></i> Encuesta aprobada por
                      monto
                    </h4>
                  </div>
                </div>
              </div>
              <div className="card-body pt-3">
                <ChartBar
                  categories={categoriesIndicatorApprovedSurveyAmount}
                  series={seriesIndicatorApprovedSurveyAmount}
                  isAmount
                />
              </div>
            </div>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            <div className="card card-chart">
              <div className="card-body px-0 pb-0 border-bottom">
                <div className="px-4">
                  <div className="d-flex justify-content-between mb-2">
                    <h4 className="card-title ml-2">
                      <i className="fa fa-bar-chart"></i> Encuesta aprobada por
                      cliente
                    </h4>
                  </div>
                </div>
              </div>
              <div className="card-body pt-3">
                <ChartBar
                  categories={categoriesIndicatorApprovedSurveyCustomer}
                  series={seriesIndicatorApprovedSurveyCustomer}
                />
              </div>
            </div>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={8}></Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column mobile={16} tablet={16} computer={8}></Grid.Column>
        </Grid.Row>
      </Grid>
    </Container>
  );
};

export default CampaignDashboard;
